import { ReactElement } from 'react';

// Components.
import { InstitutionDetails } from '../../components/InstitutionDetails';
import { InstitutionAddHeader } from './InstitutionAddHeader';

// Hooks.
import { useAccount } from 'hooks';

// Layouts.
import { ContentLayout } from 'layouts';
import { IInstitution } from '@comptia-sso/core';

export const InstitutionAddView = (): ReactElement => {
  const [account] = useAccount();
  const institution = {
    isActive: true,
    name: '',
  } as unknown as IInstitution;

  return (
    <>
      <ContentLayout
        header={<InstitutionAddHeader />}
        content={
          <InstitutionDetails
            account={account}
            mode="add"
            institution={institution}
          />
        }
      />
    </>
  );
};
